import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'simple-angular',
  templateUrl: './simple-angular.component.html',
  //styleUrl: './simple-angular.component.scss'
})
export class SimpleAngularComponent {
  @Input() inputparameter!: string;
  @Output() outputparameter = new EventEmitter<boolean>(false);
  constructor() {
    console.log('Simple Angular component loaded');
  }
  onClick() {
    console.log('event emitted in Angular');
    this.outputparameter.emit(true);
  }
}
